const autocompleteModalDocCompany = {
  documentTypes: 'Tipo do Documento',
  document: 'Documento',
};

export default autocompleteModalDocCompany;
